<footer
  class="d-none d-sm-flex my-footer-glass fixed-bottom px-4 py-1"
  [style.marginLeft.px]="marginLeft">
  <div
    class="d-flex flex-column flex-grow-1 flex-lg-row align-items-center justify-content-lg-between column-gap-2">
    <div class="d-flex flex-row align-items-center column-gap-4 row-gap-1">
      <a
        class="nav-link py-0 px-1"
        href="https://www.blum-novotest.com/footer-nav/impressum/"
        target="_blank"
        ><small>{{ "Imprint" | translate }}</small></a
      >
      <a
        class="nav-link py-0 px-1"
        href="https://www.blum-novotest.com/downloads/"
        target="_blank"
        ><small>{{ "AGB" | translate }}</small></a
      >
      <a
        class="nav-link py-0 px-1"
        href="https://www.blum-novotest.com/footer-nav/datenschutz/"
        target="_blank"
        ><small>{{ "DataProtection" | translate }}</small></a
      >
    </div>

    <small class="navbar-text justify-content-end">
      &copy; <b>{{ "Blum" | translate }} GmbH</b> Global HQ &nbsp;| &nbsp;
      Kaufstr. 14 &nbsp; | &nbsp; 88287 Grünkraut &nbsp; | &nbsp; Germany
    </small>
  </div>
</footer>

<footer class="d-flex d-sm-none my-footer-glass px-4 py-1">
  <div
    class="d-flex flex-column flex-grow-1 align-items-center justify-content-lg-between column-gap-2 my-2">
    <div class="d-flex flex-column align-items-center column-gap-4 row-gap-2">
      <a
        class="nav-link py-0 px-1"
        href="https://www.blum-novotest.com/footer-nav/impressum/"
        target="_blank"
        ><small>{{ "Imprint" | translate }}</small></a
      >
      <a
        class="nav-link py-0 px-1"
        href="https://www.blum-novotest.com/downloads/"
        target="_blank"
        ><small>{{ "AGB" | translate }}</small></a
      >
      <a
        class="nav-link py-0 px-1"
        href="https://www.blum-novotest.com/footer-nav/datenschutz/"
        target="_blank"
        ><small>{{ "DataProtection" | translate }}</small></a
      >
    </div>

    <div class="separator w-50 my-4"></div>

    <div class="d-flex flex-column gy-1 navbar-text align-items-center">
      <small
        >&copy; <b>{{ "Blum" | translate }} GmbH</b> Global HQ</small
      >
      <small>Kaufstr. 14 </small>
      <small>88287 Grünkraut</small>
      <small>Germany</small>
    </div>
  </div>
</footer>
